/**
 * MMP Metadata
 * This is a API for MMP Metadata
 *
 * The version of the OpenAPI document: 1.0.0-oas3
 * Contact: st116848@stud.uni-stuttgart.de.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { Experiment } from '../model/experiment';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class ExperimentService {

    protected basePath = 'https://localhost:8080/v1/metadata';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {

        if (configuration) {
            this.configuration = configuration;
            this.configuration.basePath = configuration.basePath || basePath || this.basePath;

        } else {
            this.configuration.basePath = basePath || this.basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }



    /**
     * adds an experiment
     * Adds an experiment
     * @param experiment Experiment item to add
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addExperiment(experiment?: Experiment, observe?: 'body', reportProgress?: boolean): Observable<Experiment>;
    public addExperiment(experiment?: Experiment, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Experiment>>;
    public addExperiment(experiment?: Experiment, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Experiment>>;
    public addExperiment(experiment?: Experiment, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Experiment>(`${this.configuration.basePath}/experiments`,
            experiment,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * experiment by id
     * Return one experiemtn by &#x60;id&#x60;
     * @param experiment The experiemnt\&#39;s id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getExperimentById(experiment: string, observe?: 'body', reportProgress?: boolean): Observable<Experiment>;
    public getExperimentById(experiment: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Experiment>>;
    public getExperimentById(experiment: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Experiment>>;
    public getExperimentById(experiment: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (experiment === null || experiment === undefined) {
            throw new Error('Required parameter experiment was null or undefined when calling getExperimentById.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<Experiment>(`${this.configuration.basePath}/experiments/${encodeURIComponent(String(experiment))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * list of experiments
     * Return list of experiemtns
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getExperiments(observe?: 'body', reportProgress?: boolean): Observable<Array<Experiment>>;
    public getExperiments(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Experiment>>>;
    public getExperiments(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Experiment>>>;
    public getExperiments(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<Array<Experiment>>(`${this.configuration.basePath}/experiments`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * update experiment by id
     * Updates an experiment
     * @param experimentId The experiemnt\&#39;s id
     * @param experiment Experiment item to updated
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateExperimentById(experimentId: string, experiment?: Experiment, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public updateExperimentById(experimentId: string, experiment?: Experiment, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public updateExperimentById(experimentId: string, experiment?: Experiment, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public updateExperimentById(experimentId: string, experiment?: Experiment, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (experimentId === null || experimentId === undefined) {
            throw new Error('Required parameter experimentId was null or undefined when calling updateExperimentById.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<any>(`${this.configuration.basePath}/experiments/${encodeURIComponent(String(experimentId))}`,
            experiment,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
